module.exports = __webpack_public_path__ + "img/g_mro_10.3cb13afa.png";